import { HandleMutationResult } from 'modules/core/lib/handleMutation'

import { withFlash } from './withFlash'

type DuplicateMutationFn = (variables: {
  formId: string
  resourceType: string
  duplicateName: string | undefined
  duplicateDescription: string | undefined
}) => HandleMutationResult<unknown>

export const createDuplicateAction = (duplicateFn: DuplicateMutationFn) => {
  return (
    formId: string,
    formResourceType: string,
    duplicateName: string | undefined,
    duplicateDescription: string | undefined
  ) =>
    withFlash(
      duplicateFn({
        formId,
        resourceType: formResourceType,
        duplicateName,
        duplicateDescription,
      })
    )
}
